'use client';
import { useState, useEffect } from 'react';
// import { useParams, useRouter } from 'next/navigation';
import { useSupabase } from '../context/SupabaseContext';
import { useParams, useNavigate} from 'react-router-dom';
import { Star } from 'lucide-react';

export default function LessonFeedback() {
  const params = useParams();
//   const router = useRouter();
  const lessonId = params.lessonId as string;
  const navigate = useNavigate();
//   const [lesson, setLesson] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(3);

  const { state, fetchLessons, addLessonFeedbackTeacher } = useSupabase();
  // Fetch lesson details
  useEffect(() => {
    fetchLessons();
  }, [fetchLessons]);

  const lesson = state.lessons.find(l => l.id === lessonId);


  const submitFeedback = async (e:any) => {

    e.preventDefault();
    setLoading(true);
    try{
      await addLessonFeedbackTeacher(lessonId, feedback, rating);
    }catch(error){
      console.error('addLessonFeedbackTeacher', error)
    }
    setLoading(false);
    navigate(`/lesson/${lessonId}`);
  };

  if (!lesson) return <div>Loading...</div>;

  return (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold mb-2">Leave Feedback</h1>
        <p className="text-gray-600">
          Help {lesson.student} improve, provide your feedback/notes or just leave a star rating for this lesson.
          <span className="font-semibold"> You can always edit this later.</span>
          <span className="font-semibold">{
            new Date(lesson.time).toLocaleDateString() == new Date().toLocaleDateString() ? ' (today)' : ``}
           {new Date(lesson.time).toLocaleDateString()}
          </span>
        </p>
      </div>

      <form onSubmit={submitFeedback} className="space-y-6">
        {/* Rating */}
        <div>
          <label className="block text-sm font-medium mb-2">How did {lesson.student} do?</label>
          <div className="flex gap-1 justify-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                  rating >= star
                    ? "text-yellow-500 fill-yellow-400 text-white"
                    : "bg-gray-100 hover:bg-gray-300 text-gray-500"
                }`}
                onClick={() => setRating(star)}
                aria-label={`Rate ${star} stars`}
              >
                <Star className="w-5 h-5 fill-current" />
              </button>
            ))}
          </div>
        </div>

        {/* Text feedback */}
        <div>
          <label className="block text-sm font-medium mb-2">Give feedback (anyone can see this)</label>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            maxLength={500}
            rows={6}
            className="w-full p-3 border border-border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Great progress on pronunciation! Try more conversation practice at home..."
          />
          <p className="text-xs text-gray-500 mt-1">
            {feedback.length}/500 characters
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 pt-4">
          <button
            type="submit"
            disabled={loading || !feedback.trim() && rating === 5}
            onClick={submitFeedback}
            className="flex-1 btn btn-primary py-3"
          >
            {loading ? 'Saving...' : 'Save Feedback'}
          </button>
        </div>
      </form>
    </div>
  );
}
